import { useBrandKit } from '../brand/BrandKitContext.tsx'

/** The Astute logo + descriptor pair — reused in the gate card and page topbars. */
export function BrandMark({ small }: { small?: boolean }) {
  const { brand } = useBrandKit()
  return (
    <div className={small ? 'brand brand--small' : 'brand'}>
      <img className="brand__logo" src={brand.logo} alt={`${brand.name} logo`} width={40} height={40} />
      <span className="brand__text">
        <span className="brand__name">{brand.name}</span>
        <span className="brand__sub">Virtual Central Office</span>
      </span>
    </div>
  )
}
